/**
 * @copyright 码小象 www.uxphp.com
 * www.yxxhui.com
 * www.mxxiang.com
 * www.mxxiang.cn
 * 自研正版源码，赋能开发者
 */
import request from '@/utils/request';

// 人员列表
export function userList(data) {
  return request({ url: 'onsite/service/staff', method: 'get', params: data });
}
/**
 * 服务分类列表
 * @param {*} data
 * @returns
 */
export function getServiceCateList(data) {
  return request({
    url: 'admin/platform/service-cate/list',
    method: 'get',
    params: data,
  });
}


/**
 * 删除
 */
export function serviceCateDelApi(data) {
  return request({
    url: 'admin/platform/service-cate/delete',
    method: 'delete',
    params: data,
  });
}
/**
 * 获取分类下拉树结构列表
 * @param {*} data
 * @returns
 */
export function getCateTierList() {
  return request({
    url: 'admin/platform/service-cate/all',
    method: 'get',
  });
}
/**
 * 服务分类添加|修改
 * @returns
 */
export function serviceCateSaveApi(data) {
  return request({
    url: `admin/platform/service-cate/save`,
    method: 'post',
    data: data,
  });
}

/**
 * 服务分类下拉选项
 */
export function serviceCateSelectApi(data) {
  return request({
    url: `admin/platform/service-cate/getFirstCate`,
    method: 'get',
    params: data,
  });
}

/**
 * 获取详情
 */
export function serviceCateInfoApi(data) {
  return request({
    url: `admin/platform/service-cate/info`,
    method: 'get',
    params: data,
  });
}
/**
 * 服务分类是否推荐
 * @param {*} data
 * @returns
 */
export function setCateRecommendShow(data) {
  return request({
    url: `admin/platform/service-cate/set_recommend`,
    method: 'put',
    params: data,
  });
}
/**
 * 服务分类显示|隐藏
 * @param {*} data
 * @returns
 */
export function setCateStatusShow(data) {
  return request({
    url: `admin/platform/service-cate/set_show`,
    method: 'put',
    params: data,
  });
}
// 获取列表
export function getServiceItemList(data) {
  return request({
    url: 'admin/platform/service-item/list',
    method: 'get',
    params: data,
  });
}

export function getSetUpList(data) {
  return request({
    url: 'admin/platform/service-staff/getSetUpList',
    method: 'get',
    params: data,
  });
}

/**
 * 删除服务项目
 */
export function serviceItemDelApi(data) {
  return request({
    url: 'admin/platform/service-item/delete',
    method: 'delete',
    params: data,
  });
}
/**
 * 服务项目保存
 * @param {*} data
 * @returns
 */
export function createItem(data) {
  return request({
    url: 'admin/platform/service-item/save',
    method: 'post',
    data: data,
  });
}

// 获取列表
export function getItemListApi (data) {
  return request({
      url: '/admin/platform/service-item/list',
      method: 'get',
      params: data
  })
}

// 是否推荐
export function ItemIsRecomApi(data) {
  return request({
    url: `admin/platform/service-item/set_Recommend`,
    method: 'put',
    params: data,
  });
}
// 是否显示
export function ItemStatusApi(data) {
  return request({
    url: `admin/platform/service-item/set_show`,
    method: 'put',
    params: data,
  });
}
// 设置是否默认
export function ItemSetDefaultApi(params) {
  return request({
    url: `admin/platform/service-item/set_default`,
    method: 'put',
    params,
  });
}
// 获取一条数据
export function readApi(id) {
  return request({
    url: `onsite/item/read/${id}`,
    method: 'GET',
  });
}

export function getCommentListApi(data) {
  return request({
    url: `admin/platform/service-order-comment/list`,
    method: 'get',
    params: data,
  });
}

/**
 * 删除订单评价
 */
export function orderCommentDelApi(data) {
  return request({
    url: `admin/platform/service-order-comment/delete`,
    method: 'delete',
    params: data,
  });
}

/**
 * 获取评价详情
 */
export function orderCommentInfoApi(data) {
  return request({
    url: `admin/platform/service-order-comment/info`,
    method: 'get',
    params: data,
  });
}

/**
 * 审核订单评价
 */
export function orderCommentVerifyApi(data) {
  return request({
    url: `admin/platform/service-order-comment/save`,
    method: 'post',
    data: data,
  });
}
/**
 * 创建技师模拟评论
 */
export function createSimulateCommentApi(data) {
  return request({
    url: `admin/platform/service-order-comment/simulate`,
    method: 'post',
    data: data,
  });
}
/**
 * 订单tabs数据
 * @param {*} data
 * @returns
 */
export function getTabsData(data) {
  return request({
    url: 'admin/platform/service-order/getOrderStatusData',
    method: 'get',
    params: data,
  });
}
/**
 * 订单列表
 * @param {*} data
 * @returns
 */
export function getOrderList(data) {
  return request({
    url: 'admin/platform/service-order/list',
    method: 'get',
    params: data,
  });
}
/**
 * 订单详情
 * @returns
 */
export function getOrderInfo(data) {
  return request({
    url: `admin/platform/service-order/info`,
    method: 'get',
    params: data,
  });
}
/**
 * 退款详情
 * @returns
 */
export function getRefundInfo(data) {
  return request({
    url: `admin/platform/service-order-refund/info`,
    method: 'get',
    params: data,
  });
}
/**
 * 处理退款
 * @param {*} data
 * @returns
 */
export function refundOrder(data) {
  return request({
    url: 'admin/platform/service-order-refund/refundOrder',
    method: 'post',
    data: data
  })
}
/**
 * 订单日志
 * @param {*} data
 * @returns
 */
export function getOrderLog(data) {
  return request({
    url: 'admin/platform/service-log/list',
    method: 'get',
    params: data,
  });
}
/**
 * 订单导出
 * @param {*} data
 * @returns
 */
export function exportOrder(data) {
  return request({
    url: 'admin/platform/service-order/export/serviceOrder',
    method: 'get',
    params: data,
  });
}
//获取服务项目标签
export function serviceLabelApi() {
  return request({
    url: 'admin/platform/service-item/serviceLabel',
    method: 'get',
  });
}
/**
 * 服务人员提现列表
 * @param {*} data
 * @returns
 */
export function getStaffExtractList(data) {
  return request({
    url: `admin/platform/service-staff-extract/list`,
    method: 'get',
    params: data,
  });
}
/**
 * 服务人员提现表单
 * @param {*} id
 * @returns
 */
export function getStaffExtractFrom(id) {
  return request({
    url: `admin/platform/service-staff-extract/info?id=${id}`,
    method: 'get',
  });
}
/**
 * 拒绝技师提现申请
 * @param {*} id
 * @param {*} data
 * @returns
 */
export function refuseStaffExtract(data) {
  return request({
    url: 'admin/platform/service-staff-extract/refuse',
    method: 'put',
    params: data,
  });
}
/**
 * 通过技师提现申请
 * @param {*} id
 * @param {*} data
 * @returns
 */
export function adoptStaffExtract(data) {
  return request({
    url: 'admin/platform/service-staff-extract/adopt',
    method: 'put',
    params: data,
  });
}
/**
 * 更新技师提现信息
 * @param {*} data
 * @returns
 */
export function updateStaffExtract(data) {
  return request({
    url: 'admin/platform/service-staff-extract/save',
    method: 'post',
    data: data,
  });
}
/**
 * 获取操作日志
 * @param {*} data
 * @returns
 */
export function getServiceLog(data) {
  return request({
    url: 'admin/platform/service-log/list',
    method: 'get',
    params: data,
  });
}
/**
 * 用户反馈列表
 * @param {*} data
 * @returns
 */
export function getSuggestList(data) {
  return request({
    url: 'admin/platform/service-suggest/list',
    method: 'get',
    params: data,
  });
}
/**
 * 用户反馈处理
 * @param {*} data
 * @returns
 */
export function verifySuggest(id) {
  return request({
    url: `admin/platform/service-suggest/verify?id=${id}`,
    method: 'get',
  });
}
/**
 * 后台获取门店已开通和未开通的服务列表
 * @param {*} company_id
 * @returns
 */
export function getCompanyOpenItemList(company_id) {
  return request({
    url: `onsite/service/item/getCompanyOpenItemList/${company_id}`,
    method: 'get',
  });
}
/**
 * 保存门店管理服务记录
 * @param {*} data
 * @returns
 */
export function createCompanyRelate(data) {
  return request({
    url: 'onsite/service/company_relate/save',
    method: 'post',
    params: data,
  });
}
/**
 * 服务详情
 * @returns
 */
export function getServiceItemInfo(data) {
  return request({
    url: `admin/platform/service-item/info`,
    method: 'get',
    params: data,
  });
}
/**
 * 技师反馈表单列表
 * @param {*} data
 * @returns
 */
export function getServiceFormList(data) {
  return request({
    url: 'admin/platform/service-form/list',
    method: 'get',
    params: data,
  });
}
/**
 * 技师反馈表单添加
 * @param {*} id
 * @returns
 */
export function createServiceForm(data) {
  return request({
    url: `admin/platform/service-form/save`,
    method: 'post',
    data: data,
  });
}
/**
 * 技师反馈表单删除
 * @param {*} data
 * @returns
 */
export function deleteServiceForm(data) {
  return request({
    url: 'admin/platform/service-form/delete',
    method: 'delete',
    params: data,
  });
}
/**
 * 技师反馈内容列表
 * @param {*} data
 * @returns
 */
export function getServiceFormDataList(data) {
  return request({
    url: 'admin/platform/service-form-data/list',
    method: 'get',
    params: data,
  });
}
/**
 * 技师反馈内容删除
 * @param {*} data
 * @returns
 */
export function deleteServiceFormData(data) {
  return request({
    url: 'admin/platform/service-form-data/delete',
    method: 'delete',
    params: data,
  });
}
/**
 * 技师反馈内容详情
 * @param {*} id
 * @returns
 */
export function getServiceFormDataInfo(data) {
  return request({
    url: `admin/platform/service-form-data/info`,
    method: 'get',
    params: data,
  });
}
/**
 * 保存技师信息
 * @param {*} data
 * @returns
 */
export function createServiceStaff(data) {
  return request({
    url: 'admin/platform/service-staff/save',
    method: 'post',
    data: data,
  });
}
/**
 * 技师详情
 * @returns
 */
export function getServiceStaffInfo(data) {
  return request({
    url: `admin/platform/service-staff/info`,
    method: 'get',
    params: data,
  });
}
/**
 * 保存技师关联服务
 * @param {*} data
 * @returns
 */
export function createStaffRelate(data) {
  return request({
    url: 'admin/platform/service-staff-relate/save',
    method: 'post',
    data: data,
  });
}
/**
 * 技师状态
 * @returns
 */
export function setStaffIsRecommend(data) {
  return request({
    url: `admin/platform/service-staff/is_recommend`,
    method: 'put',
    params: data,
  });
}
/**
 * 获取城市列表
 * @param {*} data
 * @returns
 */
export function getCityList(data) {
  return request({
    url: 'admin/platform/base-city/list',
    method: 'get',
    params: data,
  });
}

export function setStaffIsWork(data) {
  return request({
    url: `admin/platform/service-staff/work_status`,
    method: 'put',
    params: data,
  });
}

export function setStaffStatus(data) {
  return request({
    url: `admin/platform/service-staff/set_show`,
    method: 'put',
    params: data,
  });
}

export function serviceStaffDelApi(data) {
  return request({
    url: `admin/platform/service-staff/delete`,
    method: 'delete',
    params: data,
  });
}
/**
 * 技师列表
 * @param {*} data
 * @returns
 */
export function getServiceStaffList(data) {
  return request({
    url: 'admin/platform/service-staff/list',
    method: 'get',
    params: data,
  });
}
/**
 * 技师认证列表
 * @param {*} data
 * @returns
 */
export function getStaffAuthList(data) {
  return request({
    url: 'onsite/service/staff_auth/list',
    method: 'get',
    params: data,
  });
}
/**
 * 技师认证详情
 * @param {*} id
 * @returns
 */
export function getStaffAuthInfo(id) {
  return request({
    url: `onsite/service/staff_auth/info/${id}`,
    method: 'get',
  });
}
/**
 * 技师认证审核
 * @param {*} data
 * @returns
 */
export function auditStaffAuth(data) {
  return request({
    url: 'onsite/service/staff_auth/audit',
    method: 'post',
    params: data,
  });
}
/**
 * 技师反馈表单详情
 * @param {*} id
 * @returns
 */
export function getServiceFormInfo(id) {
  return request({
    url: `admin/platform/service-form/info?id=${id}`,
    method: 'get',
  });
}
/**
 * 技师反馈表单是否默认
 * @param {*} data
 * @returns
 */
export function setFormDefault(data) {
  return request({
    url: `admin/platform/service-form/setDefault`,
    method: 'put',
    params: data,
  });
}
/**
 * 技师分类显示|隐藏
 * @param {*} data
 * @returns
 */
export function setStaffCateShow(data) {
  return request({
    url: `admin/platform/service-staff-cate/set_show`,
    method: 'put',
    params: data,
  });
}
/**
 * 技师分类列表
 * @param {*} data
 * @returns
 */
export function getStaffCateList(data) {
  return request({
    url: 'admin/platform/service-staff-cate/list',
    method: 'get',
    params: data,
  });
}
/**
 * 详情
 */
export function staffCateInfoApi(data) {
  return request({
    url: `admin/platform/service-staff-cate/info`,
    method: 'get',
    params: data,
  });
}

/**
 * 新增
 */
export function staffCateSaveApi(data) {
  return request({
    url: `admin/platform/service-staff-cate/save`,
    method: 'post',
    data: data,
  });
}

/**
 * 删除分类
 */
export function staffCateDelApi(data) {
  return request({
    url: `admin/platform/service-staff-cate/delete`,
    method: 'delete',
    params: data,
  });
}
/**
 * 技师分类option
 * @returns
 */
export function getStaffCateOption() {
  return request({
    url: 'admin/platform/service-staff-cate/option',
    method: 'get',
  });
}
/**
 * 服务项目收藏列表
 * @param {*} data
 * @returns
 */
export function getItemCollectList(data) {
  return request({
    url: 'admin/platform/service-item-collect/list',
    method: 'get',
    params: data,
  });
}

/**
 * 删除项目收藏列表
 */
export function itemCollectDelApi(data) {
  return request({
    url: 'admin/platform/service-item-collect/delete',
    method: 'delete',
    params: data,
  });
}
/**
 * 技师反馈列表
 * @param {*} data
 * @returns
 */
export function getStaffSuggestList(data) {
  return request({
    url: 'admin/platform/service-staff-suggest/list',
    method: 'get',
    params: data,
  });
}
/**
 * 技师反馈删除
 * @param {*} data
 * @returns
 */
export function deleteStaffSuggest(data) {
  return request({
    url: 'admin/platform/service-staff-suggest/delete',
    method: 'delete',
    params: data,
  });
}
/**
 * 技师反馈处理
 * @param {*} id
 * @returns
 */
export function finishStaffSuggest(data) {
  return request({
    url: `admin/platform/service-staff-suggest/set_show`,
    method: 'put',
    params: data,
  });
}
/**
 * 订单报备记录列表
 * @param {*} data
 * @returns
 */
export function getOrderReportList(data) {
  return request({
    url: 'onsite/service-order_report/list',
    method: 'get',
    params: data,
  });
}
/**
 * 订单打赏记录列表
 * @param {*} data
 * @returns
 */
export function getOrderRewardList(data) {
  return request({
    url: 'admin/platform/service-order-reward/list',
    method: 'get',
    params: data,
  });
}
/**
 * 服务账单记录表
 * @param {*} data
 * @returns
 */
export function getBillList(data) {
  return request({
    url: 'admin/platform/service-bill/list',
    method: 'get',
    params: data,
  });
}
/**
 * 出行方式列表
 * @param {*} data
 * @returns
 */
export function getTravelModeList(data) {
  return request({
    url: 'admin/platform/service-travel-mode/list',
    method: 'get',
    params: data,
  });
}
/**
 * 出行方式显示|隐藏
 * @param {*} data
 * @returns
 */
export function setTravelModeShow(data) {
  return request({
    url: `admin/platform/service-travel-mode/set_show`,
    method: 'put',
    params: data,
  });
}

/**
 * 删除出行方式
 */
export function travelModeDelApi(data) {
  return request({
    url: `admin/platform/service-travel-mode/delete`,
    method: 'delete',
    params: data,
  });
}

/**
 * 获取出行方式详情
 */
export function travelModeInfoApi(data) {
  return request({
    url: `admin/platform/service-travel-mode/info`,
    method: 'get',
    params: data,
  });
}

/**
 * 保存、新增
 */
export function travelModeSaveApi(data) {
  return request({
    url: `admin/platform/service-travel-mode/save`,
    method: 'post',
    data: data,
  });
}
/**
 * 出行方式添加|修改
 * @param {*} id
 * @returns
 */
export function createTravelModel(id) {
  return request({
    url: `onsite/service/travel_mode/add/${id}`,
    method: 'get',
  });
}
/**
 * 获取服务标签
 * @returns
 */
export function getServiceLabel() {
  return request({
    url: 'admin/platform/service-staff/get_massage_service_label',
    method: 'get',
  });
}
/**
 * 获取按摩组合数据
 * @returns
 */
export function getMassageGroup() {
  return request({
    url: 'onsite/system_group/list',
    method: 'get',
  });
}
/**
 * @description 组合数据列表 -- 编辑表单
 * @param {Number} param id {Number} 组合数据id
 */
export function groupDataHeader(data, url) {
  return request({
    url: url,
    method: 'get',
    params: data,
  });
}
/**
 * @description 组合数据列表
 * @param {Number} param id {Number} 组合数据id
 */
export function groupDataList(id, url) {
  return request({
    url: url,
    method: 'get',
    params: id,
  });
}
/**
 * @description 组合数据列表 -- 修改状态
 * @param {Object} param data {Object} 组合数据列表传值
 */
export function groupDataSetApi(url) {
  return request({
    url: url,
    method: 'PUT',
  });
}
/**
 * @description 组合数据列表 -- 新增表单
 * @param {Number} param id {Number} 组合数据id
 */
export function groupDataAddApi(id, url) {
  return request({
    url: url,
    method: 'get',
    params: id,
  });
}
/**
 * @description 组合数据列表 -- 编辑表单
 * @param {Number} param id {Number} 组合数据列表id
 * @param {Object} param data {Object} 组合数据id对象
 */
export function groupDataEditApi(data, url) {
  return request({
    url: url,
    method: 'get',
    params: data,
  });
}
/**
 * 升级订单列表
 * @param {*} data
 * @returns
 */
export function getOrderUpgradeList(data) {
  return request({
    url: 'onsite/service-order_upgrade/list',
    method: 'get',
    params: data,
  });
}
/**
 * 获取加钟订单
 * @param {*} data
 * @returns
 */
export function getOrderSubjoinList(data) {
  return request({
    url: 'onsite/service-order_subjoin/list',
    method: 'get',
    params: data,
  });
}
/**
 * 隐私号码列表
 * @param {*} data
 * @returns
 */
export function getPrivateNumberList(data) {
  return request({
    url: 'admin/platform/service-private-number/list',
    method: 'get',
    params: data,
  });
}
/**
 * 隐私号显示|隐藏
 * @param {*} data
 * @returns
 */
export function setPrivateNumberShow(data) {
  return request({
    url: `admin/platform/service-private-number/set_show`,
    method: 'put',
    params: data,
  });
}

/**
 * 删除隐私号码
 */
export function privateNumberDelApi(data) {
  return request({
    url: `admin/platform/service-private-number/delete`,
    method: 'delete',
    params: data,
  });
}

/**
 * 获取隐私号码详情
 */
export function privateNumberInfoApi(data) {
  return request({
    url: `admin/platform/service-private-number/info`,
    method: 'get',
    params: data,
  });
}
/**
 * 隐私号码添加|修改
 * @returns
 */
export function privateNumberSaveApi(data) {
  return request({
    url: `admin/platform/service-private-number/save`,
    method: 'post',
    data: data,
  });
}
/**
 * 隐私号码关联列表
 * @param {*} data
 * @returns
 */
export function getOrderPrivateNumber(data) {
  return request({
    url: 'admin/platform/service-order-private-number/list',
    method: 'get',
    params: data,
  });
}

/**
 * 获取表单详情
 * @param {*} id
 * @returns
 */
export function getFormInfo(id) {
  return request({
    url: `admin/platform/service-form/info?id=${id}`,
    method: 'get',
  });
}
/**
 * 推广订单
 * @param {*} data
 * @returns
 */
export function getStairList(data) {
  return request({
    url: 'onsite/service-order/stair_list',
    method: 'get',
    params: data,
  });
}
/**
 * 语音回调列表
 * @param {*} data
 * @returns
 */
export function getPrivateNumberNotifyList(data) {
  return request({
    url: 'onsite/service/private_number_notify/list',
    method: 'get',
    params: data,
  });
}
/**
 * 下载录音文件
 * @param {*} id
 * @returns
 */
export function downloadRecord(id) {
  return request({
    url: `onsite/service/private_number_notify/download_record/${id}`,
    method: 'get',
  });
}


/**
 * 按摩首页装修数据
 * @returns
 */
 export function getMassageHome(){
  return request({
      url: 'admin/platform/uxpagediy/getMassageHome',
      method: 'get'
  })
}

/**
* 按摩首页装修保存
* @param {*} data
* @returns
*/
export function massageSaveHome(data){
  return request({
      url: 'admin/platform/uxpagediy/massageSaveHome',
      method: 'post',
      data: data
  })
}

/**
 * 按摩个人中心装修数据
 * @returns
 */
 export function getMassageUser(){
  return request({
      url: 'admin/platform/uxpagediy/getMemberMassage',
      method: 'get'
  })
}
/**
* 按摩个人中心装修保存
* @param {*} data
* @returns
*/
export function massageSaveUser(data){
  return request({
      url: 'admin/platform/uxpagediy/memberMassageSave',
      method: 'post',
      data: data
  })
}
/**
* 保存按摩颜色配置
* @param {*} data
* @returns
*/
export function massageSaveColor(data){
  return request({
      url: 'admin/platform/uxpagediy/colorSave',
      method: 'post',
      data: data
  })
}
/**
* 获取按摩颜色配置
* @returns
*/
export function getMassageColor(){
  return request({
      url: 'admin/platform/uxpagediy/getColor',
      method: 'get'
  })
}


/**
* 获取按摩技师首页配置
* @returns
*/
export function getMassageStaffHome(){
  return request({
      url: 'admin/platform/uxpagediy/getStaffHome',
      method: 'get'
  })
}
/**
* 保存技师首页数据
* @param {*} data
* @returns
*/
export function massageSaveStaffHome(data){
  return request({
      url: 'admin/platform/uxpagediy/staffSaveHome',
      method: 'post',
      data: data
  })
}
/**
* 获取技师个人中心配置
* @returns
*/
export function getMassageStaffInfo(){
  return request({
      url: 'admin/platform/uxpagediy/getMemberStaff',
      method: 'get'
  })
}
/**
* 保存技师个人中心配置
* @param {*} data
* @returns
*/
export function massageSaveStaffInfo(data){
  return request({
      url: 'admin/platform/uxpagediy/memberStaffSave',
      method: 'post',
      data: data
  })
}

export function getExtraStatistic(){
  return request({
    url: 'admin/platform/ServiceHome/platform_order_statistic',
    method: 'get',
  })
}

export function getRankingList(data){
  return request({
    url: 'admin/platform/ServiceHome/get_ranking_list',
    method: 'get',
    params:data
  })
}

export function orderChart(data){
  return request({
    url: 'admin/platform/ServiceHome/order_chart',
    method: 'get',
    params:data
  })
}

/**
 * 技师标签列表
 * @param {*} data
 * @returns
 */
export function getStaffTagList(data) {
  return request({
    url: 'admin/platform/service-staff-tag/list',
    method: 'get',
    params: data,
  });
}

/**
 * 技师标签详情
 * @param {*} data
 * @returns
 */
export function getStaffTagInfo(data) {
  return request({
    url: 'admin/platform/service-staff-tag/info',
    method: 'get',
    params: data,
  });
}

/**
 * 技师标签保存
 * @param {*} data
 * @returns
 */
export function saveStaffTag(data) {
  return request({
    url: 'admin/platform/service-staff-tag/save',
    method: 'post',
    data: data,
  });
}

/**
 * 技师标签删除
 * @param {*} data
 * @returns
 */
export function deleteStaffTag(data) {
  return request({
    url: 'admin/platform/service-staff-tag/delete',
    method: 'delete',
    params: data,
  });
}

/**
 * 技师标签显示|隐藏
 * @param {*} data
 * @returns
 */
export function setStaffTagShow(data) {
  return request({
    url: 'admin/platform/service-staff-tag/set_show',
    method: 'put',
    params: data,
  });
}

/**
 * 获取技师分类关联的标签
 * @param {*} data
 * @returns
 */
export function getStaffCateTagList(data) {
  return request({
    url: 'admin/platform/service-staff-cate-tag/list',
    method: 'get',
    params: data,
  });
}

/**
 * 保存技师分类标签关联
 * @param {*} data
 * @returns
 */
export function saveStaffCateTag(data) {
  return request({
    url: 'admin/platform/service-staff-cate-tag/save',
    method: 'post',
    data: data,
  });
}

/**
 * 获取系统标签配置
 * @returns
 */
export function getSystemTagConfig() {
  return request({
    url: 'admin/platform/system/config/get/tag',
    method: 'get',
  });
}

/**
 * 保存系统标签配置
 * @param {*} data
 * @returns
 */
export function saveSystemTagConfig(data) {
  return request({
    url: 'admin/platform/system/config/save/tag',
    method: 'post',
    data: data,
  });
}

/**
 * 技师余额列表
 * @param {*} data
 * @returns
 */
export function getStaffBalanceList(data) {
  return request({
    url: 'admin/platform/service-staff/balance/list',
    method: 'get',
    params: data,
  });
}
/**
 * 技师余额操作（增加/减少）
 * @param {*} data
 * @returns
 */
export function operateStaffBalanceApi(data) {
  return request({
    url: 'admin/platform/service-staff/balance/operate',
    method: 'post',
    data: data,
  });
}

/**
 * 确认接单（代替技师接单）
 * @param {*} data
 * @returns
 */
export function confirmAcceptOrder(data) {
  return request({
    url: 'admin/platform/service-order/confirmAccept',
    method: 'put',
    params: data,
  });
}

/**
 * 改派技师（待接单订单改派给其他技师）
 * @param {*} data
 * @returns
 */
export function reassignStaff(data) {
  return request({
    url: 'admin/platform/service-order/reassignStaff',
    method: 'put',
    params: data,
  });
}

/**
 * 技师出发 - 管理员代替技师标记已出发
 * @param {*} orderId
 * @returns
 */
export function technicianDepart(orderId) {
  return request({
    url: 'admin/platform/service-order/depart',
    method: 'put',
    params: { id: orderId },
  });
}

/**
 * 技师到达 - 管理员代替技师标记已到达
 * @param {*} orderId
 * @returns
 */
export function technicianArrive(orderId) {
  return request({
    url: 'admin/platform/service-order/arrive',
    method: 'put',
    params: { id: orderId },
  });
}

/**
 * 获取站点配置信息
 * @returns
 */
export function siteConfigApi() {
  return request({
    url: '/publicly/system/config/site_config',
    method: 'get',
  });
}

/**
 * 技师打卡 - 管理员代替技师进行现场打卡
 * @param {*} data
 * @returns
 */
export function technicianPunchCard(data) {
  return request({
    url: 'admin/platform/service-order/punch_card',
    method: 'post',
    data: data,
  });
}

/**
 * 开始服务 - 管理员代替技师标记开始提供服务
 * @param {*} orderId
 * @returns
 */
export function startService(orderId) {
  return request({
    url: 'admin/platform/service-order/start',
    method: 'put',
    params: { id: orderId },
  });
}

/**
 * 完成服务 - 管理员代替技师标记服务完成
 * @param {*} data
 * @returns
 */
export function finishService(data) {
  return request({
    url: 'admin/platform/service-order/finish',
    method: 'post',
    data: data,
  });
}

/**
 * 技师评价 - 管理员代替技师对用户进行评价
 * @param {*} data
 * @returns
 */
export function technicianComment(data) {
  return request({
    url: 'admin/platform/service-order/comment',
    method: 'post',
    data: data,
  });
}

/**
 * 获取技师排班数据
 * @param {*} data
 * @returns
 */
export function getStaffSchedule(data) {
  return request({
    url: '/admin/merchant/service-staff/schedule/get',
    method: 'get',
    params: data,
  });
}

/**
 * 保存技师排班数据
 * @param {Object} data - 排班数据
 * @param {number} data.staffId - 技师ID (必须)
 * @param {string} data.scheduleTime - 排班时间数据 (84字符hex字符串)
 * @returns {Promise}
 */
export function saveStaffSchedule(data) {
  console.log('API调用 - 输入数据:', data);
  const params = {
    staffId: data.staffId,
    scheduleTime: data.scheduleTime
  };
  console.log('API调用 - 发送参数:', params);
  
  return request({
    url: '/admin/merchant/service-staff/schedule/save',
    method: 'post',
    params: params
  });
}

/**
 * 获取城市选项列表
 * @returns {Promise}
 */
export function getCityOptions() {
  return request({
    url: '/admin/platform/base-city/option',
    method: 'get',
    params: { temp: Date.now() }
  });
}

